import { useEffect } from "react";
import { taskApi } from "../api/client";
import { useTaskStore } from "../store/taskStore";

export function useTasks() {
  const { tasks, isLoading, setTasks, addTask, updateTask, deleteTask } = useTaskStore();

  useEffect(() => {
    loadTasks();
  }, []);

  async function loadTasks() {
    useTaskStore.setState({ isLoading: true });
    try {
      const { data } = await taskApi.getAll();
      setTasks(data.data);
    } catch (err) {
      console.error("[useTasks] Failed to load:", err);
      // Load mock data as fallback
      setTasks(getMockTasks());
    }
  }

  return { tasks, isLoading, loadTasks, addTask, updateTask, deleteTask };
}

function getMockTasks() {
  return [
    { id: "1", title: "Fix authentication bypass", description: "Users can skip login by navigating directly", status: "todo" as const, priority: "critical" as const, assignee: "Alice", createdAt: "2025-01-15T10:00:00Z", updatedAt: "2025-01-15T10:00:00Z", tags: ["security", "auth"] },
    { id: "2", title: "Add rate limiting to API", description: "Prevent brute force attacks on login endpoint", status: "in-progress" as const, priority: "high" as const, assignee: "Bob", createdAt: "2025-01-14T09:00:00Z", updatedAt: "2025-01-16T14:30:00Z", tags: ["security", "api"] },
    { id: "3", title: "Update dashboard charts", description: "Replace Chart.js with Recharts for better React integration", status: "todo" as const, priority: "medium" as const, assignee: "Charlie", createdAt: "2025-01-13T08:00:00Z", updatedAt: "2025-01-13T08:00:00Z", tags: ["ui", "dashboard"] },
    { id: "4", title: "Implement task export", description: "Export tasks to CSV and JSON formats", status: "done" as const, priority: "low" as const, assignee: "Alice", createdAt: "2025-01-12T07:00:00Z", updatedAt: "2025-01-15T16:00:00Z", tags: ["feature"] },
    { id: "5", title: "Database migration v2", description: "Add indexes for performance optimization", status: "in-progress" as const, priority: "high" as const, assignee: "Dave", createdAt: "2025-01-11T06:00:00Z", updatedAt: "2025-01-16T11:00:00Z", tags: ["database", "performance"] },
    { id: "6", title: "Setup CI/CD pipeline", description: "Configure GitHub Actions for automated deployment", status: "done" as const, priority: "medium" as const, assignee: "Eve", createdAt: "2025-01-10T05:00:00Z", updatedAt: "2025-01-14T12:00:00Z", tags: ["devops"] },
  ];
}
